(function(angular){
	'use strict';

	angular
		.module('modalModule')
		.controller('RemoveDeviceModalController', [
			'$rootScope',
			'close',
			'device',
			'ignoreClose',
			'SettingsFactory',
			RemoveDeviceModalFunction
		]);

	function RemoveDeviceModalFunction(
		$rootScope,
		close,
		device,
		ignoreClose,
		SettingsFactory
	){
		var removeDevice = this;
		removeDevice.device = device;
		removeDevice.close = close;
		removeDevice.ignoreClose = ignoreClose;

		removeDevice.handleDelete = function () {
			SettingsFactory.knownLoginDevices.delete(removeDevice.device.deviceId)
				.then(function () {
					close({
						success: true,
						deviceId: removeDevice.device.deviceId
					});
				}).catch(function () {
				urlFactory.redirect("/account/security/your-devices/manage");
			});
		};
	}
})(window.angular);